<div class="btn-bottom-wrap">
  <button
    *ngIf="tienePermiso('GestionarAnular')"
    class="SiguienteButton"
    (click)="abrirModalConfirmacionAnulacion()"
    title="{{ 'ANULAR' | translate }}"
    [disabled]="!puedeAnularVenta()"
  >
    {{ 'ANULAR' | translate }}
  </button>
  <button
    *ngIf="tienePermiso('GestionarDevolver')"
    class="SiguienteButton"
    (click)="devolucionParcial()"
    title="{{ 'DEVOLVER' | translate }}"
    [disabled]="!puedeDevolverVenta()"
  >
    {{ 'DEVOLVER' | translate }}
  </button>
  <button
    *ngIf="tienePermiso('GestionarModificar')"
    class="SiguienteButton"
    (click)="modificarVenta()"
    title="{{ 'MODIFICAR' | translate }}"
    [disabled]="!puedeModificarVenta()"
  >
    {{ 'MODIFICAR' | translate }}
  </button>
  <button
    *ngIf="tienePermiso('GestionarFacturar')"
    class="SiguienteButton"
    (click)="abrirModalDeImprimirFactura()"
    title="{{ 'FACTURAR' | translate }}"
    [disabled]="!puedeFacturar()"
  >
    {{ 'FACTURAR' | translate }}
  </button>
  <button
    *ngIf="tienePermiso('GestionarImprimir')"
    class="SiguienteButton"
    (click)="abrirOpcionesDeImpresion()"
    title="{{ 'IMPRIMIR' | translate }}"
    [disabled]="!puedeImprimirVenta()"
  >
    {{ 'IMPRIMIR' | translate }}
  </button>
</div>
